/* Aurora Home Studio – theme.js */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveal ---------- */
  function initReveal(root) {
    var els = $$('[data-reveal]:not(.is-in)', root);
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- header, scroll, to-top ---------- */
  var header = $('#SiteHeader'), toTop = $('#ToTop');
  function onScroll() {
    var y = window.scrollY || document.documentElement.scrollTop;
    if (header) header.classList.toggle('is-stuck', y > 30);
    if (toTop) toTop.classList.toggle('is-show', y > 600);
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  if (toTop) toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* ---------- mobile menu & search ---------- */
  var menu = $('#MobileMenu');
  function setMenu(open) { if (!menu) return; menu.classList.toggle('is-open', open); menu.setAttribute('aria-hidden', !open); document.body.style.overflow = open ? 'hidden' : ''; }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-menu]')) setMenu(true);
    if (e.target.closest('[data-close-menu]')) setMenu(false);
    var st = e.target.closest('[data-toggle-search]');
    if (st) {
      var p = $('#SearchPanel'); p.hidden = !p.hidden;
      if (!p.hidden) { var i = $('input[type=search]', p); i && i.focus(); }
    }
    if (e.target.closest('[data-toggle-filters]')) { var f = $('[data-filters]'); f && f.classList.toggle('is-open'); }
    if (e.target.closest('[data-show-recover]')) { e.preventDefault(); $('#LoginBox').hidden = true; $('#RecoverBox').hidden = false; }
    if (e.target.closest('[data-show-login]')) { e.preventDefault(); $('#RecoverBox').hidden = true; $('#LoginBox').hidden = false; }
    var ed = e.target.closest('[data-edit-address]');
    if (ed) { e.preventDefault(); var b = $('#EditAddress-' + ed.dataset.editAddress); b.hidden = !b.hidden; }
    var del = e.target.closest('[data-delete-address]');
    if (del) {
      e.preventDefault();
      if (confirm('Delete this address?')) {
        var f2 = document.createElement('form'); f2.method = 'post'; f2.action = del.dataset.url;
        f2.innerHTML = '<input type="hidden" name="_method" value="delete">';
        document.body.appendChild(f2); f2.submit();
      }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setMenu(false); setCart(false); } });

  /* ---------- tabs ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    $$('[data-tab]', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-tab]', wrap).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        $$('[data-panel]', wrap).forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === btn.dataset.tab); });
      });
    });
  });

  /* ---------- slider ---------- */
  $$('[data-slider]').forEach(function (s) {
    var track = $('.slider__track', s), timer;
    function step(dir) {
      var card = track.firstElementChild; if (!card) return;
      var w = card.getBoundingClientRect().width + 22;
      if (dir > 0 && track.scrollLeft + track.clientWidth >= track.scrollWidth - 8) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    $('[data-prev]', s).addEventListener('click', function () { step(-1); });
    $('[data-next]', s).addEventListener('click', function () { step(1); });
    function play() { if (!reduce) timer = setInterval(function () { step(1); }, 5000); }
    s.addEventListener('mouseenter', function () { clearInterval(timer); });
    s.addEventListener('mouseleave', play);
    play();
  });

  /* ---------- counters ---------- */
  function runCounter(el) {
    var target = parseFloat(el.dataset.count) || 0, dur = 1800, t0 = null;
    if (reduce) { el.textContent = target.toLocaleString(); return; }
    function tick(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1), eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString();
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  var counters = $$('[data-count]');
  if (counters.length) {
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { runCounter(x.target); cio.unobserve(x.target); } });
      }, { threshold: 0.5 });
      counters.forEach(function (c) { cio.observe(c); });
    } else counters.forEach(runCounter);
  }

  /* ---------- countdown ---------- */
  $$('[data-countdown]').forEach(function (box) {
    var raw = (box.dataset.countdown || '').trim(), end = raw ? new Date(raw.replace(' ', 'T')).getTime() : NaN;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var target = end;
      if (isNaN(target) || target < Date.now()) { var d = new Date(); d.setHours(23, 59, 59, 999); target = d.getTime(); }
      var diff = Math.max(0, target - Date.now()), s = Math.floor(diff / 1000);
      var map = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      Object.keys(map).forEach(function (k) { var n = $('[data-cd=' + k + ']', box); if (n) n.textContent = pad(map[k]); });
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- quick search bar ---------- */
  $$('[data-qsearch]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var kw = $('[data-qs-kw]', f).value.trim(), cat = $('[data-qs-cat]', f).value, price = $('[data-qs-price]', f).value;
      if (kw) { window.location.href = '/search?type=product&q=' + encodeURIComponent(kw); return; }
      var url = cat || '/collections/all', qs = [];
      if (price) {
        var p = price.split('-');
        if (p[0]) qs.push('filter.v.price.gte=' + encodeURIComponent(p[0]));
        if (p[1]) qs.push('filter.v.price.lte=' + encodeURIComponent(p[1]));
      }
      window.location.href = url + (qs.length ? '?' + qs.join('&') : '');
    });
  });

  /* ---------- auto submit filters ---------- */
  $$('[data-auto-submit]').forEach(function (i) {
    i.addEventListener('change', function () { i.form && i.form.submit(); });
  });

  /* ---------- quantity buttons (product + cart page) ---------- */
  document.addEventListener('click', function (e) {
    var inc = e.target.closest('[data-qty-inc]'), dec = e.target.closest('[data-qty-dec]');
    if (!inc && !dec) return;
    var input = $('input', (inc || dec).parentNode); if (!input) return;
    var min = parseInt(input.min || '0', 10), v = parseInt(input.value || '0', 10) + (inc ? 1 : -1);
    input.value = Math.max(min, v);
  });

  /* ---------- cart drawer ---------- */
  var drawer = $('#CartDrawer');
  var useDrawer = document.body.dataset.cartDrawer === 'true' && drawer;
  function setCart(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open); drawer.setAttribute('aria-hidden', !open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  function refreshCart(openAfter) {
    return fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
      var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      var fresh = $('.drawer__inner', doc), cur = $('.drawer__inner', drawer);
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); });
      if (openAfter) setCart(true);
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-close-cart]')) setCart(false);
    var link = e.target.closest('[data-cart-link]');
    if (link && useDrawer) { e.preventDefault(); refreshCart(true); }
    var q = e.target.closest('[data-qty-change]');
    if (q) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: q.dataset.key, quantity: parseInt(q.dataset.qty, 10) }) })
        .then(function () { return refreshCart(false); });
    }
  });

  /* ---------- ajax add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.js-add-form'); if (!form) return;
    if (form.dataset.ajax === 'off') return;
    e.preventDefault();
    var btn = $('button[type=submit]', form), label = btn && btn.innerHTML;
    if (btn) { btn.disabled = true; btn.style.opacity = '.7'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { alert(res.j.description || res.j.message || 'Could not add to cart'); return; }
        if (btn) btn.innerHTML = '✓ Added';
        if (useDrawer) return refreshCart(true); else window.location.href = '/cart';
      })
      .catch(function () { form.dataset.ajax = 'off'; form.submit(); })
      .then(function () { setTimeout(function () { if (btn) { btn.disabled = false; btn.style.opacity = ''; btn.innerHTML = label; } }, 1200); });
  });

  /* ---------- product page: variants & gallery ---------- */
  $$('[data-product-section]').forEach(function (sec) {
    var jsonEl = $('[data-variants-json]', sec), form = $('[data-product-form]', sec) || $('.pdp__form', sec);
    if (!jsonEl || !form) return;
    var variants = JSON.parse(jsonEl.textContent);

    function showMedia(id) {
      if (!id) return;
      $$('.pdp__slide', sec).forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId == id); });
      $$('.pdp__thumb', sec).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb == id); });
    }
    $$('.pdp__thumb', sec).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });

    function current() {
      var sel = $$('.opt', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
      if (!sel.length) return variants[0];
      return variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
    }
    form.addEventListener('change', function (e) {
      if (!e.target.closest('.opt')) return;
      var fs = e.target.closest('.opt'), lab = $('[data-opt-label]', fs); if (lab) lab.textContent = e.target.value;
      var v = current(), btn = $('[data-add-btn]', form), lbl = $('[data-add-label]', form);
      if (!v) { btn.disabled = true; lbl.textContent = 'Unavailable'; return; }
      $('[data-variant-id]', form).value = v.id;
      $('[data-price]', sec).textContent = v.price;
      var cmp = $('[data-compare]', sec), save = $('[data-save]', sec);
      cmp.hidden = !v.sale; save.hidden = !v.sale;
      if (v.sale) { cmp.textContent = v.compare; save.textContent = 'Save ' + v.off + '%'; }
      btn.disabled = !v.available; lbl.textContent = v.available ? 'Add to cart' : 'Sold out';
      showMedia(v.media);
      if (window.history.replaceState) window.history.replaceState({}, '', window.location.pathname + '?variant=' + v.id);
    });
  });

  /* ---------- related products (recommendations) ---------- */
  $$('[data-recs]').forEach(function (box) {
    fetch(box.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), fresh = $('[data-recs]', doc);
      if (fresh && fresh.innerHTML.trim()) { box.innerHTML = fresh.innerHTML; initReveal(box); }
      else box.remove();
    }).catch(function () { box.remove(); });
  });

  /* ---------- theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
  initReveal(document);
})();
